import React from 'react';
import Project from '../../../../../components/Forms/projects/index';

function PMEProjects() {
  return <Project module="pme" namespace="PMEProject"/>
};

export default PMEProjects;
